<template>
    <div>
        <viewFile v-if="uid_file" :uid_element="uid_file"></viewFile>
        <div v-show="treatment_params.length > 0">
            <treatment_params ref="treatment_params"></treatment_params>
        </div>
        <div v-show="treatment_params.length == 0">
            <div>Commentaire</div>
            <b-textarea v-model="comment"></b-textarea>
        </div>
        <br />
        <b-button variant="success" @click="send">{{ text_send }}</b-button>
    </div>
</template>

<script>
    
    import * as json2csv from "json2csv";

    import viewFile from "./viewFile.vue";
	import projects from "../services/projects.js";
	import treatments from "../services/treatments.js";
	import document_service from "../services/document.js";
	import treatment_params from "../components/treatment_params.vue"

    export default {
        nme: "validate",
		components: {
            viewFile,
            treatment_params
		},
		props: {
			options: {
				default: null
            },
            data: {
                default: {}
            },
            default_project: {
                default: ""
            }
        },
		data() {
			return {
                comment: "",
                uid_file: null,
                uid_project: null,
                text_send: "Lu",
                treatment_params: []
			};
        },
        methods: {
            async send()
            {
                var comment = {
                    comment: this.comment
                }

                if (this.uid_file && this.treatment_params.length == 0)
                    await document_service.update(this.uid_file, false, false, comment);

                if (this.uid_project)
                {
                    var data = this.data;

                    if (this.treatment_params.length == 0)
                        data.comment = this.comment;

                    data = [data];

                    var csv = json2csv.parse(data, {
                        fields: Object.keys(data[0]),
                        fieldNames: Object.keys(data[0]),
                    });
                    csv = new Blob([csv], {
                        type: "text/plain",
                    });

                    var formData = new FormData();

                    if (this.treatment_params.length > 0)
                    {
                        formData.set("params", JSON.stringify(this.$refs.treatment_params.get()));
                        console.log(JSON.stringify(this.$refs.treatment_params.get()));
                    }

                    var treatment_data = await treatments.create(
                        this.uid_project,
                        null,
                        csv,
                        "data.csv",
                        null,
                        "import",
                        formData
                    ).catch((err) => {
                        console.log("error : " + err);
                        this.$notify({
                            group: "info",
                            title: err.response.data.msg,
                            type: "error",
                        });
                    });
                }

                this.$emit("done");
            }
        },
        async created()
        {
            if (this.options.startsWith("{"))
            {
                var options = JSON.parse(this.options);
                this.uid_project = options.project || this.default_project;
                this.uid_file = options.file;
                if (options.text_send)
                    this.text_send = options.text_send;

                var project = await projects.get(this.uid_project)
                this.treatment_params = project.details.treatment_params || [];
				await this.$refs.treatment_params.set(this.treatment_params);
            }
            else
            {
                this.uid_project = this.default_project;
                this.uid_file = this.options;
            }
        }
    }
</script>
